/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 16:25:27 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import {
  ChipField,
  Datagrid,
  DateField,
  List,
  ReferenceArrayField,
  SelectField,
  SingleFieldList,
  TextField,
  usePermissions,
  Title,
} from 'react-admin';
import ListActions from './actions';
import ListFilter from './filter';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import { adStatusOptions } from 'utils/choices';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const AdvertList = props => {
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        bulkActionButtons={false}
        actions={<ListActions />}
        filters={<ListFilter />}
        perPage={25}
        pagination={<PostPagination />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="name"
            label="resources.Advert.fields.adName"
            sortable={false}
          />
          <TextField
            source="advertiserName"
            label="resources.Advert.fields.advertiserName"
            sortable={false}
          />
          <DateField
            source="startDate"
            label="resources.Advert.fields.liveDate"
            sortable={false}
          />
          <DateField
            source="endDate"
            label="resources.Advert.fields.endDate"
            sortable={false}
          />
          <ReferenceArrayField
            label="resources.Advert.fields.regions"
            reference="Region"
            source="regionsIds"
            sortable={false}
          >
            <SingleFieldList>
              <ChipField source="name" />
            </SingleFieldList>
          </ReferenceArrayField>
          <SelectField
            source="status"
            label={'resources.Advert.fields.status'}
            choices={adStatusOptions}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default AdvertList;
